export default {
    markdown: {
        skipConditionLists: [
            [
                {
                    operator: 'equal',
                    path: 'text',
                    value: undefined,
                },
            ],
        ],
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/markdown.ts